<template>
        <div class="row justify-content-center">
            <div class="col-lg-5 col-md-7">
                <div class="card bg-secondary shadow border-0">
                    <div class="card-header bg-transparent pb-5">
                        <div class="text-muted text-center mt-2">Logged out</div>
                        <!-- <div class="text-muted text-center mt-2 mb-3"><small>Sign in with</small></div>
                        <div class="btn-wrapper text-center">
                            <a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/github.svg"></span>
                                <span class="btn-inner--text">Github</span>
                            </a>
                            <a href="#" class="btn btn-neutral btn-icon">
                                <span class="btn-inner--icon"><img src="img/icons/common/google.svg"></span>
                                <span class="btn-inner--text">Google</span>
                            </a>
                        </div> -->
                    </div>
                    <div class="card-body px-lg-5 py-lg-5">
                        <div class="text-center text-muted mb-4">
                            ออกจากระบบแล้ว
                        </div>
                        <!-- <div class="text-center text-muted mb-4">
                            <small>Or sign in with credentials</small>
                        </div>
                        <form role="form" v-on:submit="login">
                            <base-input class="input-group-alternative mb-3"
                                        placeholder="อีเมล"
                                        addon-left-icon="ni ni-email-83"
                                        v-model="model.username">
                            </base-input>

                            <base-input class="input-group-alternative"
                                        placeholder="รหัสผ่าน"
                                        type="password"
                                        addon-left-icon="ni ni-lock-circle-open"
                                        v-model="model.password">
                            </base-input>

                            <base-checkbox class="custom-control-alternative">
                                <span class="text-muted">Remember me</span>
                            </base-checkbox>
                            <div class="text-center">
                                <base-button type="primary" class="my-4" v-on:click="login">เข้าสู่ระบบ</base-button>
                            </div>
                        </form> -->
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-6">
                        <a href="#" class="text-light"><small>ลืมรหัสผ่าน?</small></a>
                    </div>
                    <div class="col-6 text-right">
                        <router-link to="/login" class="text-light"><small>เข้าสู่ระบบบัญชีของคุณ</small></router-link>
                    </div>
                </div>
            </div>
        </div>
</template>
<script>
  import JwService from '../service/justwash';

  export default {
    // name: 'login',
    // data() {
    //   return {
    //     model: {
    //       username: '',
    //       password: ''
    //     }
    //   }
    // },
    mounted() {
      // this.$isLoading(false)

      axios({
        method: 'post',
        url: JwService.getAPI()+'/api/method/justwash.OwnerApi.logout',
        headers: {
          'Authorization' : 'Token '+localStorage.getItem('accessToken')
        }
      }).then((response) => {
        // console.log(response.data.message);
        if (response.data.message.status == true) {
          // this.loginData = response.data.message.data;
          // for (let idx in  response.data.message.data) {
          //   console.log(idx)
          // }
          // console.log(this.loginData);
          // console.log(response.data.message.data);
          // console.log('Logout success');
          localStorage.clear();
          // this.$router.push('/logout');
        } else {
          // localStorage.clear();
          this.$router.push('/login')
          // console.log('Logout Fail');
        }
      }).catch(error => {
        console.log(error)
        this.$router.push('/login')
      });
    }
  }
</script>
<style>
</style>
